/**
 * Shared product-page FAQs — used by the visible FAQ accordion on the
 * product detail page and by the FAQPage JSON-LD in SEO.jsx.
 * Copy is written for SEO: direct answers, Ontario delivery keywords.
 */
export const productFaqs = [
  {
    q: 'Does it fit through a standard doorway?',
    a: 'Yes. Most of our dressers, wardrobes and bedroom furniture are designed to fit through a standard 30 to 36 inch Canadian doorway. Check the Dimensions row in the specifications table above and measure your hallway and door frames before delivery day.',
  },
  {
    q: 'Is assembly required?',
    a: 'No assembly required. Your furniture arrives fully assembled and ready to place. Our delivery team can help position it in your room on request.',
  },
  {
    q: 'What is the delivery time in Ontario?',
    a: 'Delivery across Ontario typically takes 3 to 5 business days after your order is confirmed. We deliver to Toronto, Ottawa, Mississauga, Brampton, Hamilton and surrounding cities — enter your city at checkout to see your exact delivery window.',
  },
];

export default productFaqs;
